import { render, staticRenderFns } from "./IndexAuction.vue?vue&type=template&id=2b83d22d&scoped=true&"
import script from "./IndexAuction.vue?vue&type=script&lang=js&"
export * from "./IndexAuction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83d22d",
  null
  
)

export default component.exports